"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOlapicCategory = void 0;
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _models = require("../models");
var _utils = require("../utils");
var _externalUrl = require("./externalUrl");
/* istanbul ignore file @preserve --api */

const fetchOlapicCategory = async ({
  apiKey,
  customerId,
  tag
}) => {
  const {
    apiDomain,
    apiVersion
  } = _externalUrl.baseConfig;
  const url = `${apiDomain}customers/${customerId}/categories/search?tag_key=${tag}&auth_token=${apiKey}&version=${apiVersion}`;
  return (0, _externalUrl.getExternalUrl)(url, {
    responseType: 'json'
  });
};
const getOlapicCategory = async ({
  apiKey,
  customerId,
  tag
}) => {
  const defaultCategory = {
    created: Date.now(),
    name: '',
    id: '',
    tag
  };
  const expireTime = (0, _externalUrl.getExpireTime)(_externalUrl.cacheMinutes.categories);
  const localStorageData = (0, _utils.loadFromLocalStorage)(_utils.LocalStorageNames.categories);
  if (localStorageData) {
    const category = localStorageData.find(item => item.tag === tag && item.created > expireTime);
    if (category) {
      return {
        local: true,
        category
      };
    }
  }
  const response = await fetchOlapicCategory({
    apiKey,
    customerId,
    tag
  });
  return (0, _presentationHttp.validateResponse)(response, {
    schema: _models.olapicResponseCategorySchema,
    onError: () => ({
      local: true,
      category: defaultCategory
    }),
    onSuccess: ({
      data
    }) => {
      const result = data.data;
      return {
        local: false,
        category: {
          ...defaultCategory,
          name: result.name,
          id: result.id
        }
      };
    }
  });
};
const useGetOlapicCategory = ({
  apiKey,
  customerId,
  tag,
  enabled = true
}) => {
  const shouldFetch = Boolean(apiKey && customerId && tag && enabled);
  const {
    data,
    error
  } = (0, _fetching.useSWR)(shouldFetch ? [apiKey, customerId, tag] : null, async () => getOlapicCategory({
    apiKey,
    customerId,
    tag
  }), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onSuccess: ({
      local,
      category
    }) => {
      if (local) {
        return;
      }
      const categories = (0, _utils.loadFromLocalStorage)(_utils.LocalStorageNames.categories) ?? [];
      const expireTime = (0, _externalUrl.getExpireTime)(_externalUrl.cacheMinutes.categories);
      const updatedCategories = categories.filter(item => item.created > expireTime);
      updatedCategories.push(category);
      (0, _utils.saveToLocalStorage)(_utils.LocalStorageNames.categories, updatedCategories);
    }
  });
  return {
    data,
    isLoading: data === undefined && error === undefined,
    isError: Boolean(error)
  };
};
exports.useGetOlapicCategory = useGetOlapicCategory;
